import SVG from "../SVG";
import { useState } from "react";

export default function PassWord({
  placeholder = "",
  id = "",
  passwordBlur,
  setPasswordBlur,
  passwordValid,
  formValue,
  formOnChange,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggle = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      style={
        passwordBlur && !passwordValid
          ? { border: "0.5px solid #ef4444" }
          : null
      }
      className="w-full border bg-zi-bg2-light dark:bg-zi-bg2-dark hocus-within:bg-zi-bg1-light hocus-within:dark:bg-zi-bg1-dark border-zi-border-light dark:border-zi-border-dark rounded-lg flex items-center justify-between overflow-auto hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-light gap-1"
    >
      <input
        type={showPassword ? "text" : "password"}
        id={id}
        placeholder={placeholder}
        className="text-base w-full p-2 outline-none bg-transparent text-zi-text-light dark:text-zi-text-dark [direction:ltr] text-end"
        value={formValue}
        onChange={formOnChange}
        onClick={() => {
          if (!setPasswordBlur) return;
          setPasswordBlur(false);
        }}
        onBlur={() => {
          if (!setPasswordBlur) return;
          setPasswordBlur(true);
        }}
      />

      <button
        type="button"
        tabIndex="-1"
        onClick={handleToggle}
        className="p-2"
      >
        <SVG
          name={showPassword ? "eye" : "eyeClosed"}
          classname={
            showPassword
              ? "stroke-zi-blue-dark dark:stroke-white"
              : "fill-zi-blue-dark dark:fill-white"
          }
        />
      </button>

      <style>
        {`
          input[type="password"]::-ms-reveal,
          input[type="password"]::-ms-clear {
            display: none !important;
          }
        `}
      </style>
    </div>
  );
}
